import { HeaderControlsProvider } from "~/components/contexts/useHeaderControlsContext"
import { ProductsAGECTable } from "~/pages/Brand/Regulations/AGEC/ProductsAGECTable.tsx"

export const ProductsAGECWrapper = () => {
  return (
    <HeaderControlsProvider>
      <ProductsAGECTable />
    </HeaderControlsProvider>
  )
}
